import React from 'react';
import { shape, string, bool } from 'prop-types';
import Image from 'components/Image';
import BylineImagePlaceholder from 'components/BylineImagePlaceholder';

const MAX_BYLINE_IMAGE_SIZE = 48;

const getAuthorMarkup = (author, isAmp) => (
  <span className="Post__author">
    {!isAmp && (
      <span className="Post__authorImageWrap">
        {author.imageUrl && (
          <Image
            className="Post__authorImage"
            url={author.imageUrl}
            alt={author.name}
            maxSize={{ width: MAX_BYLINE_IMAGE_SIZE, aspectRatio: 1 }}
            sourceSizes={[
              {
                layoutWidth: {
                  value: MAX_BYLINE_IMAGE_SIZE,
                  units: `px`
                }
              }
            ]}
            renderOps={{
              width: MAX_BYLINE_IMAGE_SIZE,
              height: MAX_BYLINE_IMAGE_SIZE
            }}
          />
        )}
        {!author.imageUrl && <BylineImagePlaceholder size={16} />}
      </span>
    )}
    <span className="Post__authorIndicator">by</span> {author.name}
  </span>
);

const createAuthorEl = (author, isAmp) =>
  author.authorUrl ? (
    <a className="Post__author-link" href={author.authorUrl}>
      {getAuthorMarkup(author, isAmp)}
    </a>
  ) : (
    getAuthorMarkup(author, isAmp)
  );

const NATIVE_AD_AUTHOR = 'Creative Studio';

/**
 * outputs a byline for use at the top of a Post page
 *
 */
function PostByline(props) {
  const { author, isAmp } = props;
  const isNativeAuthor = author.name === NATIVE_AD_AUTHOR;

  return (
    <div
      className={`Post__byline-author ${
        isNativeAuthor ? 'Post__byline-author--empty' : ''
      }`}
    >
      {!isNativeAuthor ? createAuthorEl(author, isAmp) : null}
    </div>
  );
}

PostByline.propTypes = {
  author: shape({
    name: string.isRequired,
    imageUrl: string,
    authorUrl: string
  }).isRequired,
  isAmp: bool.isRequired
};

PostByline.defaultProps = {};

export default PostByline;
